<template>
  <div class="fip-casting">
    <h2> {{ $t('fip.casting.title') }} </h2>
    <div class="list">
      <wptv-carousel
        :responsive-rules="responsiveRules"
        :with-margins="false">
        <wptv-carousel-item
          v-for="(person, index) in casting"
          :key="index"
          class="list-item">
          <fip-casting-detail
            :person="person"
            :is-director="isDirector(person)"
            class="fip-casting-detail-item" />
        </wptv-carousel-item>
      </wptv-carousel>
    </div>
  </div>
</template>

<script>
import FipCastingDetail from './fipCastingDetail/FipCastingDetail'
import { WptvCarousel, WptvCarouselItem } from '@wptv/components/ui/carousel'

export default {
  name: 'FipCasting',
  components: {
    FipCastingDetail,
    WptvCarousel,
    WptvCarouselItem
  },

  props: {
    video: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      responsiveRules: { xxsmall: 5, xsmall: 5, small: 5, medium: 5, large: 5, xlarge: 5, xxlarge: 5 }
    }
  },
  computed: {
    casting () {
      return [...this.video.directors.slice(0, 1), ...this.video.actors.slice(0, 4)] // 1 director and 4 actors (5)
    }
  },

  methods: {
    isDirector (person) {
      return this.video.directors.includes(person)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-casting {
    max-width: 1280px;
    margin: auto;
    padding: 0px 15px;
    @include mediaQueries('padding', (medium: 0px 27px, large: 0px 55px, xlarge: 0px 55px));

    .list {
      display: flex;
      flex-direction: row;
      margin-top: 37px;

      .list-item {
        width: 117px;
        @include mediaQueries('width', (medium: 157px, large: 170px));

        &:not(:last-child) {
          margin-right: 27px;
          @include mediaQueries('margin-right', (medium: 27px, large: 30px));
        }
      }
    }
  }

</style>
